import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-579c83e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid container-lg bg-light mt-4 mb-8" }
const _hoisted_2 = {
  key: 0,
  class: "col-2 edit-icon move-icon flex-column"
}
const _hoisted_3 = {
  key: 1,
  class: "col-2 edit-icon"
}
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = { class: "col-12 d-flex align-items-center justify-content-center" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "d-flex align-items-center justify-content-around" }
const _hoisted_8 = { class: "d-none d-lg-flex align-items-center" }
const _hoisted_9 = { class: "m-0" }
const _hoisted_10 = { class: "m-0 ms-4" }
const _hoisted_11 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_12 = {
  key: 0,
  class: "list-properties"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "border-top pt-3" }, "List Properties", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "curateKeySelect"
}, "List Curate Key", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "border-top my-4 p-3" }
const _hoisted_17 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "m-0 mx-3" }, "List DID Filters", -1))
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "list-group list-group-flush" }
const _hoisted_21 = { class: "filter-item" }
const _hoisted_22 = { class: "m-0 me-3" }
const _hoisted_23 = { class: "d-flex align-items-center justify-content-center mt-3" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Save Properties and Filters")

import { ref, Ref, onMounted } from "vue";
import { useRoute } from 'vue-router';
import {
    MDBBtn,
    MDBSpinner,
    MDBIcon,
    MDBFooter,
    MDBInput
} from "mdb-vue-ui-kit";
import FeedArticle from "@/components/FeedArticle.vue";
import { getKeyPairs, getList, putList } from '@/functions/store';
import { extractRef } from '@/functions/utility';
import { List } from '@/types/List';
import { Article } from "@/types/Article";
import { downloadList, uploadList } from "@/functions/list";
import { useEventsBus } from '@/functions/utility';
import { KeyPair } from "@/types/KeyPair";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { emit } = useEventsBus();
const route = useRoute();

// setup universal vars
const gettingArticles = ref(false);
const editMode = ref(true);
const fullEdit = ref(false);
const unsavedChanges = ref(false);
const processingList = ref(false);
const list = ref<List>({
    key: '',
    name: '',
    articles: [],
    url: '',
    filters: []
});
const articles: Ref<Article[]> = ref([]);
const listKey = route.params.listKey;

// list setup
const savingProperties = ref(false);
const listImportName = ref('');
const listImportEndpoint = ref('');
const listCurateKey = ref();
const curateKeys: Ref<KeyPair[]> = ref([]);
const filters: Ref<string[]> = ref([]);
const newFilter = ref('');

/**
* Get Articles for the List
*/
async function getData() {
    gettingArticles.value = true;

    // get curate keys as well
    curateKeys.value = await getKeyPairs('curate');

    const listResp = await getList(listKey as string);
    const storedList = listResp[0];
    list.value = storedList;

    // update list property fields
    listImportName.value = storedList.name;
    listImportEndpoint.value = storedList.url;
    listCurateKey.value = storedList.key;
    filters.value = storedList.filters;

    for (let i = 0; i < storedList.articles.length; i++) {
        const article = storedList.articles[i];

        articles.value.push(article);
    }

    gettingArticles.value = false;
}

/**
* Remove Article from the List
*
* @param i Array Location of Article
*/
function removeArticle(i: number) {
    unsavedChanges.value = true;
    articles.value.splice(i, 1);
}

/**
* Save Current Changes to List
*/
async function saveCurrentList() {
    processingList.value = true;

    // save current articles
    const currentList = extractRef(list);
    currentList.articles = extractRef(articles);

    // store current list
    try {
        await putList(currentList);
    } catch (error) {
        return console.error(error);
    }

    processingList.value = false;
    unsavedChanges.value = false;
}

/**
* Reset all changes to Current List
*/
async function resetCurrentList() {
    processingList.value = true;

    // get old list
    const oldList = extractRef(list);
    articles.value = [];

    for (let i = 0; i < oldList.articles.length; i++) {
        const article = oldList.articles[i];

        articles.value.push(article)
    }

    processingList.value = false;
    unsavedChanges.value = false;
}

async function uploadCurrentList() {
    if (list.value === null) {
        emit('newAlert', 'List is Not Defined');
        return false;
    }

    if (unsavedChanges.value) {
        unsavedChanges.value = false;
        await saveCurrentList();
    }

    processingList.value = true;
    const listToUpload: List = list.value;

    const uploadResp = await uploadList(listToUpload);

    // alert user of success
    emit('newAlert', uploadResp.message);

    processingList.value = false;
}

async function downloadCurrentList() {
    if (list.value === null) {
        emit('newAlert', 'List is Not Defined');
        return false;
    }

    processingList.value = true;
    const listToDownload: List = extractRef(list);

    const downloadResp = await downloadList(listToDownload);

    if (downloadResp.success === false) {
        emit('newAlert', downloadResp.message);
        processingList.value = false;
        return false;
    }

    articles.value = downloadResp.data.articles;

    processingList.value = false;
    unsavedChanges.value = true;
}

/**
* Change Positioning of a Article in a list
*
* @param current Current Article Location
* @param newPos Article's Desired New Location
*/
function changeListPosition(current: number, newPos: number) {
    // remove specified article
    const article = articles.value.splice(current, 1)[0];

    // place in new position
    articles.value.splice(newPos, 0, article);
    unsavedChanges.value = true;
}

async function saveProperties() {
    savingProperties.value = true;

    // assemble new list values
    const newFilters = extractRef(filters);
    const currentList = extractRef(list);
    const updatedList: List = {
        key: listCurateKey.value,
        name: listImportName.value,
        url: listImportEndpoint.value,
        filters: newFilters,
        articles: currentList.articles
    }

    // save new list values
    try {
        await putList(updatedList);
    } catch (error) {
        return console.error(error);
    }

    savingProperties.value = false;
}

function addFilter() {
    if (filters.value.indexOf(newFilter.value) == -1) {
        filters.value.push(newFilter.value);
    }
    newFilter.value = '';
}

onMounted(async () => {
    await getData();
});

return (_ctx: any,_cache: any) => {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(MDBBtn), {
      color: "primary",
      floating: "",
      size: "lg",
      class: _normalizeClass(gettingArticles.value ? 'loader-div loading' : 'loader-div')
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MDBSpinner))
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_draggable, {
        modelValue: articles.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((articles).value = $event)),
        onChange: _cache[1] || (_cache[1] = () => { unsavedChanges.value = true })
      }, {
        default: _withCtx(() => [
          _createVNode(_TransitionGroup, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles.value, (article, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row justify-content-center my-3",
                  key: 'article-' + article.infoHash
                }, [
                  (editMode.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_unref(MDBIcon), {
                          onClick: ($event: any) => (changeListPosition(index, 0)),
                          title: "Move to beginning of list",
                          icon: "angle-double-up",
                          iconStyle: "fas",
                          size: "2x"
                        }, null, 8, ["onClick"]),
                        _createVNode(_unref(MDBIcon), {
                          onClick: ($event: any) => (changeListPosition(index, --index)),
                          title: "Move up 1 position",
                          icon: "angle-up",
                          iconStyle: "fas",
                          size: "2x"
                        }, null, 8, ["onClick"]),
                        _createVNode(_unref(MDBIcon), {
                          icon: "grip-lines",
                          iconStyle: "fas",
                          size: "2x",
                          title: "Move article"
                        }),
                        _createVNode(_unref(MDBIcon), {
                          onClick: ($event: any) => (changeListPosition(index, ++index)),
                          title: "Move down 1 position",
                          icon: "angle-down",
                          iconStyle: "fas",
                          size: "2x"
                        }, null, 8, ["onClick"]),
                        _createVNode(_unref(MDBIcon), {
                          onClick: ($event: any) => (changeListPosition(index, --articles.value.length)),
                          title: "Move to end of list",
                          icon: "angle-double-down",
                          iconStyle: "fas",
                          size: "2x"
                        }, null, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(editMode.value ? 'col-8' : 'col-12 col-lg-8')
                  }, [
                    _createVNode(FeedArticle, {
                      article: article.metainfo,
                      smallImage: editMode.value
                    }, null, 8, ["article", "smallImage"])
                  ], 2),
                  (editMode.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_unref(MDBIcon), {
                          icon: "trash",
                          title: "Remove article",
                          iconStyle: "fas",
                          size: "2x",
                          onClick: ($event: any) => (removeArticle(index))
                        }, null, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (articles.value.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", null, _toDisplayString(gettingArticles.value ? `Getting List articles..` : 'No articles available'), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (gettingArticles.value === false && editMode.value)
      ? (_openBlock(), _createBlock(_unref(MDBFooter), {
          key: 0,
          bg: "primary",
          text: ['white', 'center'],
          class: "fixed-bottom p-3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h3", _hoisted_9, _toDisplayString(list.value.name), 1),
                  _createElementVNode("h5", _hoisted_10, _toDisplayString(articles.value.length) + " articles", 1),
                  (unsavedChanges.value)
                    ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                        key: 0,
                        class: "ms-4",
                        icon: "exclamation-circle",
                        iconStyle: "fas",
                        title: "There are unsaved changes"
                      }))
                    : _createCommentVNode("", true)
                ]),
                (processingList.value)
                  ? (_openBlock(), _createBlock(_unref(MDBSpinner), { key: 0 }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (unsavedChanges.value)
                        ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                            key: 0,
                            onClick: saveCurrentList,
                            icon: "save",
                            iconStyle: "fas",
                            size: "2x",
                            class: "me-4",
                            title: "Save List Changes"
                          }))
                        : _createCommentVNode("", true),
                      (unsavedChanges.value)
                        ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                            key: 1,
                            onClick: resetCurrentList,
                            icon: "undo",
                            iconStyle: "fas",
                            size: "2x",
                            class: "me-4",
                            title: "Undo All List Changes"
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(MDBIcon), {
                        onClick: downloadCurrentList,
                        icon: "cloud-download-alt",
                        iconStyle: "fas",
                        size: "2x",
                        class: "me-4",
                        title: "Download List to get Updates"
                      }),
                      _createVNode(_unref(MDBIcon), {
                        onClick: uploadCurrentList,
                        icon: "cloud-upload-alt",
                        iconStyle: "fas",
                        size: "2x",
                        class: "me-4",
                        title: unsavedChanges.value ? 'Save and Upload List' : 'Upload List'
                      }, null, 8, ["title"]),
                      (fullEdit.value)
                        ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                            key: 2,
                            icon: "caret-down",
                            title: "Hide List properties",
                            iconStyle: "fas",
                            size: "2x",
                            class: "me-4",
                            onClick: _cache[2] || (_cache[2] = () => fullEdit.value = false)
                          }))
                        : (_openBlock(), _createBlock(_unref(MDBIcon), {
                            key: 3,
                            icon: "caret-up",
                            title: "Show List properties",
                            iconStyle: "fas",
                            size: "2x",
                            class: "me-4",
                            onClick: _cache[3] || (_cache[3] = () => fullEdit.value = true)
                          })),
                      _createVNode(_unref(MDBIcon), {
                        icon: "times",
                        title: "Stop Editing",
                        iconStyle: "fas",
                        size: "2x",
                        onClick: _cache[4] || (_cache[4] = () => editMode.value = false)
                      })
                    ]))
              ]),
              (fullEdit.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_unref(MDBInput), {
                      type: "text",
                      class: "my-4",
                      size: "lg",
                      white: "",
                      label: "Import List Name",
                      modelValue: listImportName.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((listImportName).value = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_unref(MDBInput), {
                      type: "text",
                      class: "my-4",
                      size: "lg",
                      white: "",
                      label: "Import List Url Endpoint",
                      modelValue: listImportEndpoint.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((listImportEndpoint).value = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_14,
                    _withDirectives(_createElementVNode("select", {
                      id: "curateKeySelect",
                      class: "form-select",
                      "aria-label": "List Curate Key",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((listCurateKey).value = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curateKeys.value, (pair) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: 'curatekeys-' + pair.kid,
                          value: pair.kid
                        }, _toDisplayString(pair.kid), 9, _hoisted_15))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, listCurateKey.value]
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_unref(MDBInput), {
                            type: "text",
                            size: "lg",
                            white: "",
                            label: "New DID Filter",
                            placeholder: "did:psqr:{hostname}/{path}",
                            modelValue: newFilter.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newFilter).value = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_unref(MDBIcon), {
                            class: "mx-3",
                            icon: "plus",
                            title: "Add DID Filter",
                            iconStyle: "fas",
                            size: "2x",
                            onClick: addFilter
                          })
                        ])
                      ]),
                      _createElementVNode("ul", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filters.value, (filter, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "list-group-item filter-group-item bg-primary",
                            key: filter + '-' + index
                          }, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("p", _hoisted_22, _toDisplayString(filter), 1),
                              _createVNode(_unref(MDBIcon), {
                                icon: "trash",
                                title: "Remove Filter",
                                iconStyle: "fas",
                                size: "1x",
                                onClick: () => filters.value.splice(index, 1)
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      (savingProperties.value)
                        ? (_openBlock(), _createBlock(_unref(MDBSpinner), { key: 0 }))
                        : (_openBlock(), _createBlock(_unref(MDBBtn), {
                            key: 1,
                            outline: "light",
                            onClick: saveProperties,
                            size: "lg"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24
                            ]),
                            _: 1
                          }))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (gettingArticles.value === false && editMode.value === false)
      ? (_openBlock(), _createBlock(_unref(MDBBtn), {
          key: 1,
          color: "primary",
          floating: "",
          size: "lg",
          class: "loader-div loading"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MDBIcon), {
              icon: "edit",
              title: "Edit List",
              iconStyle: "fas",
              onClick: _cache[9] || (_cache[9] = () => editMode.value = true)
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})